import type React from "react";

interface CesiumLoadingBackgroundProps {
  className?: string;
  style?: React.CSSProperties;
}

const CesiumLoadingBackground: React.FC<CesiumLoadingBackgroundProps> = ({
  className,
  style,
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      style={{
        width: "100%",
        height: "100%",
        minWidth: "100%",
        minHeight: "100%",
        zIndex: 1002,
        display: "block",
        ...style,
      }}
      viewBox="0 0 497 342"
      preserveAspectRatio="xMidYMid slice"
      role="img"
      aria-label="Cesium loading animation"
      className={className}
    >
      <g
        transform="translate(0.000000,342.000000) scale(0.100000,-0.100000)"
        fill="#f9f8f7"
        stroke="none"
      >
        <path
          d="M0 3288 c1 -106 4 -139 18 -164 l17 -32 70 42 c39 23 104 62 145 86
41 24 92 54 113 67 21 13 52 32 70 42 123 69 147 83 147 87 0 2 -130 4 -290 4
l-290 0 0 -132z"
        />
        <path
          d="M600 3386 c-30 -18 -99 -59 -152 -91 -76 -45 -95 -60 -90 -73 4 -10
31 -57 60 -105 28 -48 52 -92 52 -96 0 -5 3 -11 8 -13 4 -1 32 -46 62 -98 30
-52 64 -110 76 -128 13 -18 24 -38 26 -44 4 -10 71 27 506 285 89 54 164 97
166 97 2 0 37 20 77 45 59 36 75 52 85 82 8 23 10 39 4 41 -6 2 -10 8 -10 14
0 5 -15 34 -32 64 l-33 54 -375 0 -375 -1 -55 -33z"
        />
        <path
          d="M1480 3415 c0 -3 14 -27 30 -54 26 -41 37 -50 69 -56 33 -5 47 0 117
41 43 26 90 53 104 61 22 11 2 13 -147 13 -95 0 -173 -2 -173 -5z"
        />
        <path
          d="M2010 3413 c0 -5 10 -75 22 -156 l21 -148 56 6 c31 3 79 10 106 15
28 4 85 14 127 21 l78 13 -6 35 c-3 20 -11 77 -17 126 l-13 90 -187 3 c-103 1
-187 -1 -187 -5z"
        />
        <path
          d="M2455 3368 c4 -29 12 -84 18 -123 11 -66 14 -70 36 -67 65 7 355 52
358 56 2 2 -4 45 -13 95 l-17 91 -194 0 -194 0 6 -52z"
        />
        <path
          d="M2903 3383 c3 -21 9 -62 13 -90 7 -58 10 -59 79 -43 22 5 92 16 155
25 170 23 162 21 156 55 -3 17 -9 44 -12 60 l-6 30 -195 0 -196 0 6 -37z"
        />
        <path
          d="M3326 3368 c4 -29 8 -55 10 -57 2 -2 94 9 204 25 l201 28 -3 26 -3
25 -208 3 -208 2 7 -52z"
        />
        <path
          d="M3770 3401 c0 -11 3 -22 8 -24 7 -5 246 28 266 37 6 2 -53 5 -131 5
-135 1 -143 0 -143 -18z"
        />
        <path
          d="M4260 3392 c0 -16 4 -53 10 -83 5 -30 12 -74 14 -99 16 -132 64 -452
70 -458 3 -2 85 8 183 23 220 34 208 32 268 40 28 3 76 11 108 17 l57 11 0
288 0 289 -355 0 -355 0 0 -28z"
        />
        <path
          d="M4130 3399 c-25 -5 -76 -13 -115 -18 -122 -16 -220 -35 -226 -44 -3
-4 -2 -29 3 -55 4 -26 26 -168 48 -317 22 -148 42 -275 45 -282 2 -6 12 -9 22
-7 56 14 389 62 397 57 8 -6 4 86 -7 142 -3 11 -8 46 -12 79 -3 32 -8 68 -10
80 -2 11 -11 71 -20 131 -8 61 -20 140 -26 178 -12 75 -10 73 -99 56z"
        />
        <path
          d="M1873 3383 c-18 -9 -33 -20 -33 -25 0 -4 -6 -8 -12 -8 -7 0 -35 -15
-63 -32 -27 -17 -68 -41 -90 -53 -33 -18 -41 -28 -46 -59 -5 -34 5 -54 130
-264 151 -251 133 -235 236 -217 28 5 55 9 60 9 13 2 11 25 -41 363 -24 160
-44 294 -44 297 0 12 -66 4 -97 -11z"
        />
        <path
          d="M3530 3307 c-102 -17 -186 -31 -188 -33 -2 -1 4 -46 12 -101 9 -54
32 -201 51 -327 19 -125 37 -231 40 -234 3 -3 83 6 178 21 94 15 182 27 195
27 33 0 34 -6 -36 440 -29 183 -40 235 -52 236 -8 1 -98 -12 -200 -29z"
        />
        <path
          d="M3103 3242 c-89 -15 -164 -30 -167 -33 -3 -3 14 -136 39 -295 25
-159 48 -306 51 -326 7 -45 10 -45 148 -23 50 8 124 19 165 26 l73 11 -5 42
c-3 22 -21 145 -41 271 -19 127 -39 257 -43 290 -10 74 -1 72 -220 37z"
        />
        <path
          d="M275 3194 c-38 -19 -80 -43 -130 -75 -22 -14 -48 -28 -58 -32 -32
-12 -28 -34 21 -118 26 -46 90 -157 142 -246 52 -90 98 -163 104 -163 11 0
131 69 192 111 23 16 44 26 46 23 3 -2 10 2 17 10 9 11 3 29 -34 89 -25 41
-45 80 -45 86 0 6 -4 11 -8 11 -5 0 -16 15 -25 33 -9 17 -30 55 -47 82 -16 28
-47 79 -67 115 -56 97 -58 99 -108 74z"
        />
        <path
          d="M2672 3174 c-84 -12 -159 -25 -165 -27 -14 -4 -10 -78 9 -170 8 -38
14 -85 14 -105 0 -64 4 -65 116 -47 54 8 137 21 184 28 l85 12 -3 70 c-2 61
-23 194 -38 248 -6 21 -10 21 -202 -9z"
        />
        <path
          d="M1435 3124 c-59 -36 -192 -114 -510 -302 -88 -52 -230 -135 -315
-184 -85 -49 -172 -101 -193 -114 l-37 -24 51 -83 c29 -45 61 -98 71 -117 75
-132 50 -115 284 -200 l62 -22 123 74 c68 41 203 121 299 178 96 56 240 142
320 189 80 48 171 102 202 121 l56 33 -31 56 c-17 31 -35 58 -39 59 -4 2 -8 8
-8 12 0 5 -17 37 -38 72 -22 35 -65 107 -97 160 -64 109 -68 113 -110 122 -24
5 -43 -1 -90 -30z"
        />
        <path
          d="M2327 3118 c-7 -4 -28 -8 -47 -8 -30 0 -211 -28 -217 -33 -1 -1 5
-43 12 -92 8 -50 19 -124 26 -165 6 -41 11 -76 12 -76 1 -1 79 11 172 27 94
16 174 29 179 29 10 0 5 55 -21 217 l-18 113 -43 -3 c-24 -1 -49 -5 -55 -9z"
        />
        <path d="M1 3084 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
        <path
          d="M13 3043 c-9 -3 -13 -37 -13 -118 l0 -114 61 -128 c33 -70 72 -151
86 -179 l26 -52 71 38 c39 21 72 42 73 47 2 6 -15 39 -37 74 -22 35 -45 75
-51 89 -5 13 -13 27 -17 30 -4 3 -15 21 -24 40 -10 19 -28 53 -41 75 -54 95
-120 205 -121 204 0 0 -7 -3 -13 -6z"
        />
        <path
          d="M2770 2825 c-80 -12 -160 -25 -178 -28 -19 -3 -36 -8 -39 -11 -6 -6
33 -295 41 -303 3 -3 42 0 88 6 102 15 292 44 295 46 2 1 -34 242 -43 288 -3
15 -9 27 -12 26 -4 -1 -72 -11 -152 -24z"
        />
        <path
          d="M4770 2774 c-80 -13 -176 -28 -215 -34 -38 -5 -98 -15 -132 -21 -75
-13 -72 -2 -42 -192 11 -73 22 -145 24 -162 8 -93 19 -131 46 -158 35 -34 45
-83 30 -142 -12 -47 -2 -85 21 -85 7 0 24 -12 39 -26 15 -14 32 -24 37 -20 5
3 52 77 103 164 l94 159 80 12 c44 7 88 14 98 17 16 5 17 26 17 260 l0 254
-27 -1 c-16 -1 -93 -12 -173 -25z"
        />
        <path
          d="M2285 2751 c-155 -24 -170 -28 -168 -46 11 -84 42 -288 45 -291 5 -4
348 45 359 52 3 2 -2 56 -12 121 -10 65 -20 134 -22 153 -3 20 -10 36 -18 37
-8 1 -90 -11 -184 -26z"
        />
        <path
          d="M1 2068 c-1 -373 2 -678 7 -678 16 0 146 51 176 69 17 10 73 41 125
67 98 50 207 139 217 178 5 23 -4 42 -103 210 -35 58 -71 110 -82 115 -10 6
-27 31 -37 56 -11 25 -22 45 -26 45 -5 0 -8 4 -8 9 0 5 -22 55 -49 112 -27 57
-62 138 -79 179 -16 41 -52 122 -79 180 -28 58 -52 112 -56 120 -3 8 -6 -290
-6 -662z"
        />
        <path
          d="M2015 2709 c-11 -4 -37 -8 -57 -8 -27 -1 -38 -5 -38 -16 0 -26 65
-120 149 -217 46 -53 47 -42 20 137 -16 110 -26 124 -74 104z"
        />
        <path
          d="M4160 2679 c-154 -24 -231 -36 -370 -55 -91 -13 -334 -55 -340 -59
-4 -3 -4 -22 0 -42 8 -35 90 -589 90 -606 0 -12 36 -8 222 20 144 21 178 29
178 42 0 9 -7 57 -15 106 -8 50 -24 158 -35 240 -12 83 -23 161 -26 175 -2 14
-7 46 -11 71 -5 41 -3 47 16 52 11 3 23 1 26 -3 6 -9 20 -80 29 -145 3 -22 10
-69 15 -105 6 -36 20 -137 32 -225 12 -88 25 -163 28 -167 3 -4 28 -3 54 2 26
5 80 14 120 19 40 6 117 17 172 25 55 9 103 16 106 16 3 0 11 17 17 38 14 47
2 95 -33 132 -23 24 -29 47 -59 259 -19 128 -35 233 -37 235 -2 1 -83 -10
-179 -25z"
        />
        <path
          d="M1760 2599 c-47 -28 -118 -71 -158 -95 -40 -24 -75 -44 -78 -44 -3 0
-24 -13 -47 -29 -23 -15 -73 -46 -112 -68 -183 -104 -485 -286 -485 -291 0 -4
39 -22 88 -41 122 -47 255 -97 337 -127 39 -15 90 -34 115 -44 124 -50 233
-90 244 -90 6 0 40 62 75 138 35 75 92 196 127 267 68 144 84 220 64 312 -14
63 -60 163 -74 163 -6 0 -49 -24 -96 -51z"
        />
        <path
          d="M3275 2544 c-44 -7 -113 -19 -153 -25 -40 -7 -75 -15 -77 -19 -3 -5
1 -43 9 -87 13 -73 31 -182 72 -450 12 -79 22 -113 31 -113 26 0 299 40 328
49 21 5 29 13 28 27 -1 10 -9 66 -18 124 -29 190 -75 502 -75 506 0 7 -64 2
-145 -12z"
        />
        <path
          d="M2920 2490 c-19 -5 -55 -11 -80 -14 -99 -13 -232 -34 -236 -39 -3 -2
5 -73 17 -156 l23 -151 35 5 c20 3 64 10 99 15 34 6 92 15 129 22 37 6 79 11
93 12 34 1 35 22 7 181 -25 140 -25 140 -87 125z"
        />
        <path
          d="M1982 2474 c-28 -20 -30 -69 -3 -84 29 -15 56 -12 74 8 24 26 21 57
-8 76 -30 20 -35 20 -63 0z"
        />
        <path
          d="M2480 2420 c-19 -4 -92 -16 -162 -25 -70 -10 -131 -21 -137 -24 -16
-10 28 -307 45 -305 5 1 81 12 169 25 88 12 165 26 172 31 12 9 11 16 -13 173
-18 115 -23 135 -32 134 -4 -1 -23 -4 -42 -9z"
        />
        <path
          d="M2040 2319 c-40 -16 -59 -39 -91 -108 -17 -36 -53 -112 -80 -169 -27
-57 -49 -110 -49 -117 0 -7 -4 -15 -9 -17 -10 -3 -57 -105 -67 -143 -7 -29 -1
-32 211 -109 72 -26 139 -51 150 -56 76 -32 136 -53 140 -48 4 4 -18 169 -60
433 -8 50 -22 142 -31 205 -19 140 -37 160 -114 129z"
        />
        <path
          d="M4878 2233 c-81 -15 -82 -16 -126 -95 -11 -18 -63 -105 -117 -193
-54 -88 -114 -187 -134 -220 l-36 -60 -65 -11 c-36 -6 -118 -19 -182 -29 -65
-10 -118 -21 -118 -24 0 -3 20 -19 45 -36 24 -16 45 -33 45 -37 0 -3 24 -23
53 -44 28 -20 57 -42 62 -49 6 -6 31 -25 57 -43 25 -18 54 -39 63 -48 8 -9 43
-37 77 -63 34 -25 85 -64 114 -86 28 -22 74 -56 100 -75 27 -19 59 -45 72 -58
23 -22 25 -22 38 -5 51 64 77 111 108 194 l36 94 0 453 c0 248 -3 452 -7 451
-5 -1 -43 -8 -85 -16z"
        />
        <path
          d="M2970 2154 c-14 -3 -50 -8 -80 -13 -30 -5 -93 -15 -140 -22 -47 -7
-88 -15 -92 -18 -4 -3 -2 -39 4 -80 l11 -74 56 7 c31 3 119 16 196 28 l140 23
-14 78 c-14 83 -12 81 -81 71z"
        />
        <path
          d="M483 2071 c-40 -20 -75 -39 -79 -43 -3 -4 17 -45 45 -92 28 -47 64
-107 79 -133 47 -82 203 -346 207 -351 1 -2 158 83 174 94 8 6 -332 564 -343
562 -6 0 -43 -17 -83 -37z"
        />
        <path
          d="M2529 2086 c-2 -2 -69 -14 -149 -26 -80 -12 -149 -25 -153 -30 -7 -6
6 -111 18 -147 3 -8 15 -9 42 -3 21 5 99 19 173 30 74 12 138 24 142 28 4 4 2
40 -4 80 -11 68 -13 72 -38 72 -15 0 -29 -2 -31 -4z"
        />
        <path
          d="M643 2058 c9 -13 75 -122 148 -243 73 -121 138 -226 145 -233 9 -11
24 -7 83 22 39 20 71 33 71 28 0 -4 -29 -22 -65 -40 -37 -18 -65 -38 -65 -47
0 -21 6 -20 74 23 70 44 96 55 96 42 0 -6 -5 -10 -10 -10 -6 0 -39 -19 -75
-42 -44 -30 -63 -48 -59 -58 3 -8 35 -66 72 -128 37 -62 77 -129 89 -150 12
-20 25 -42 30 -47 10 -13 49 -80 70 -123 9 -18 22 -31 27 -29 9 3 148 210 176
262 9 17 -3 45 -81 180 -51 88 -97 170 -103 182 -14 29 -21 28 -75 -2 -54 -31
-67 -26 -14 6 21 12 46 29 56 38 18 15 18 16 0 22 -15 5 -13 8 12 14 34 9 135
63 135 73 0 7 -68 35 -240 100 -58 22 -189 71 -292 111 -103 39 -195 71 -204
71 -15 0 -15 -2 -1 -22z m567 -353 c0 -10 -91 -66 -102 -63 -6 2 13 18 43 36
60 34 59 34 59 27z"
        />
        <path
          d="M4305 1985 c-44 -7 -129 -21 -190 -30 -60 -9 -110 -17 -111 -18 -2
-3 40 -292 43 -296 2 -3 130 16 335 51 67 11 67 12 89 57 12 25 34 65 50 88
35 50 36 64 8 83 -12 8 -41 30 -65 48 -47 35 -45 35 -159 17z"
        />
        <path
          d="M2905 1954 c-38 -8 -83 -16 -100 -18 -138 -16 -135 -13 -113 -105 11
-50 12 -51 42 -47 70 11 245 37 296 44 61 9 58 4 45 95 l-6 47 -47 -1 c-26 0
-78 -7 -117 -15z"
        />
        <path
          d="M3880 1920 c-25 -4 -85 -13 -135 -19 -103 -15 -107 -15 -157 -26 -21
-4 -38 -9 -38 -11 0 -16 32 -209 42 -252 11 -49 13 -53 37 -48 14 3 87 14 161
26 217 32 200 28 200 56 0 14 -4 44 -9 67 -5 23 -15 81 -21 130 -8 54 -16 86
-24 86 -6 -1 -31 -5 -56 -9z"
        />
        <path
          d="M2528 1890 c-14 -4 -55 -11 -90 -14 -101 -11 -188 -29 -188 -40 0
-11 39 -261 45 -292 3 -12 17 -25 37 -32 18 -6 87 -31 153 -57 97 -37 128 -45
161 -40 l40 6 -23 147 c-12 81 -28 189 -34 240 l-12 92 -31 -1 c-17 0 -43 -4
-58 -9z"
        />
        <path
          d="M3465 1860 c-22 -4 -96 -15 -165 -25 -161 -22 -152 -19 -146 -57 26
-154 38 -231 40 -255 4 -32 -10 -32 176 -3 192 30 177 24 184 67 6 47 -25 276
-39 278 -5 1 -28 -1 -50 -5z"
        />
        <path
          d="M3023 1794 c-6 -3 -81 -15 -165 -28 -139 -20 -153 -24 -151 -41 4
-39 45 -300 48 -303 2 -3 188 25 328 49 43 8 66 16 64 23 -3 7 -15 78 -28 159
l-24 147 -30 -1 c-16 0 -35 -3 -42 -5z"
        />
        <path
          d="M1350 1754 c-95 -51 -97 -54 -68 -100 46 -73 118 -204 118 -214 0 -5
4 -10 8 -10 5 0 17 -18 27 -40 10 -23 22 -43 27 -46 11 -7 184 353 175 363 -5
5 -210 83 -217 82 -3 0 -34 -16 -70 -35z"
        />
        <path
          d="M529 1659 c-6 -12 -23 -33 -38 -45 -26 -24 -167 -114 -178 -114 -3 0
-31 -16 -62 -34 -54 -33 -198 -96 -231 -101 -12 -1 -16 -20 -18 -91 l-3 -90
43 -17 c30 -13 56 -36 88 -78 25 -32 73 -95 107 -138 35 -44 63 -84 63 -89 0
-10 51 -31 129 -54 33 -10 50 -23 74 -58 17 -25 49 -68 71 -96 23 -28 47 -60
54 -70 7 -11 16 -23 20 -29 4 -5 22 -18 40 -28 l33 -19 67 47 c124 85 127 88
111 124 -8 17 -17 31 -22 31 -14 0 -25 44 -14 58 5 7 7 15 4 18 -3 3 -1 17 4
31 7 19 6 30 -3 42 -7 9 -18 25 -24 36 -75 138 -117 209 -127 216 -5 3 -9 10
-9 15 -1 5 -12 27 -27 49 -14 22 -26 42 -26 45 -2 10 -38 75 -50 90 -29 36
-25 47 36 85 32 20 59 38 59 41 0 6 -17 35 -57 98 -18 28 -33 54 -33 58 0 15
-50 88 -60 88 -5 0 -14 -10 -21 -21z"
        />
        <path
          d="M1686 1655 c-9 -13 -25 -46 -35 -72 -11 -26 -50 -111 -87 -188 l-67
-140 12 -82 c16 -113 17 -116 55 -109 45 9 282 46 311 48 14 1 25 7 25 13 1 5
-16 123 -37 262 l-38 252 -56 21 c-69 25 -63 25 -83 -5z"
        />
        <path
          d="M1873 1588 c3 -18 15 -103 27 -188 27 -205 39 -260 56 -267 12 -4
247 26 330 42 l20 4 -21 147 -20 147 -75 27 c-41 15 -122 44 -180 65 -58 20
-109 41 -114 46 -19 18 -28 8 -23 -23z"
        />
        <path
          d="M3956 1563 c-2 -3 -191 -35 -326 -57 -20 -3 -24 -9 -22 -27 3 -26 20
-151 28 -214 4 -22 9 -43 13 -47 5 -6 122 9 324 43 37 6 67 14 67 18 0 25 -22
186 -32 233 -9 45 -16 56 -30 55 -11 -1 -20 -3 -22 -4z"
        />
        <path
          d="M4060 1553 c0 -5 9 -69 21 -143 11 -74 33 -219 48 -322 15 -103 29
-189 31 -190 3 -2 46 -33 95 -68 50 -35 129 -92 176 -127 48 -34 88 -63 91
-63 3 0 20 22 39 50 19 27 37 50 42 50 4 0 7 5 7 10 0 12 48 81 103 146 20 25
37 50 37 56 0 6 9 18 20 28 19 17 19 17 -3 38 -12 11 -107 86 -212 167 -104
80 -199 154 -210 163 -11 9 -64 50 -118 91 -53 41 -97 78 -97 84 0 6 -3 8 -6
4 -3 -3 -15 3 -27 14 -21 20 -37 25 -37 12z"
        />
        <path
          d="M838 1488 c-78 -42 -90 -54 -64 -64 17 -6 156 77 156 93 0 19 -8 17
-92 -29z"
        />
        <path
          d="M3340 1460 c-118 -20 -294 -49 -390 -65 -96 -15 -178 -30 -182 -34
-3 -3 4 -67 16 -141 17 -105 25 -135 36 -133 31 4 371 55 495 74 72 11 168 25
213 31 83 11 84 11 78 37 -3 14 -13 76 -22 136 -9 61 -19 115 -23 121 -4 7
-76 -2 -221 -26z"
        />
        <path
          d="M885 1459 c-27 -17 -59 -35 -72 -40 -13 -5 -23 -13 -23 -19 0 -11 47
-98 143 -265 96 -168 92 -158 81 -213 -13 -65 1 -96 53 -113 l37 -12 43 49
c23 27 43 54 43 59 1 6 14 25 30 44 l30 35 -29 50 c-33 61 -157 267 -168 281
-4 6 -15 24 -23 40 -8 17 -19 35 -23 40 -5 6 -18 28 -30 49 -12 22 -27 41 -32
43 -6 2 -33 -11 -60 -28z"
        />
        <path
          d="M2313 1418 c3 -18 11 -72 18 -119 6 -48 15 -92 19 -99 6 -9 37 -8
141 6 l134 19 -3 50 c-2 28 -9 55 -15 61 -7 6 -66 31 -132 54 -66 24 -124 47
-129 52 -23 20 -38 8 -33 -24z"
        />
        <path
          d="M660 1389 c-25 -15 -44 -31 -43 -34 1 -3 3 -10 5 -16 4 -11 108 38
108 51 0 4 -6 12 -12 18 -9 7 -26 1 -58 -19z"
        />
        <path
          d="M697 1356 c-21 -13 -43 -28 -48 -33 -10 -10 19 -72 76 -163 12 -19
57 -97 99 -172 42 -76 83 -138 90 -138 24 0 63 46 70 83 6 32 1 47 -36 109
-23 40 -54 93 -68 118 -92 167 -125 220 -134 219 -6 0 -28 -11 -49 -23z"
        />
        <path
          d="M1411 1154 c-29 -43 -50 -85 -49 -93 3 -13 16 -15 68 -13 35 1 67 5
71 10 10 11 -11 145 -26 161 -11 11 -22 0 -64 -65z"
        />
        <path
          d="M4010 1223 c-115 -18 -291 -43 -318 -45 -31 -2 -51 -26 -38 -47 8
-12 39 -210 39 -243 0 -33 3 -33 118 -14 46 8 126 20 178 27 103 14 116 25
100 84 -4 16 -13 75 -19 130 -12 101 -16 116 -28 114 -4 -1 -18 -4 -32 -6z"
        />
        <path
          d="M2570 1183 c-14 -2 -65 -10 -114 -18 -49 -8 -92 -17 -95 -20 -4 -5
53 -407 66 -463 5 -20 10 -22 35 -17 35 8 107 19 237 37 l93 12 -6 51 c-8 59
-35 233 -45 290 -7 40 -8 40 -49 38 -45 -2 -47 1 -54 67 -3 26 -19 32 -68 23z"
        />
        <path
          d="M4960 1177 c0 -11 -22 -45 -85 -133 -25 -34 -10 -68 46 -103 l49 -30
0 139 c0 77 -2 140 -5 140 -3 0 -5 -6 -5 -13z"
        />
        <path
          d="M3406 1135 c-81 -13 -149 -25 -151 -27 -1 -2 7 -73 19 -158 20 -142
23 -155 41 -153 84 11 337 53 344 58 6 3 6 17 2 33 -8 24 -18 85 -37 225 -6
45 -8 47 -38 46 -17 -1 -98 -12 -180 -24z"
        />
        <path
          d="M2110 1113 c-85 -14 -156 -26 -158 -28 -2 -2 4 -47 12 -101 9 -55 21
-130 27 -169 5 -38 15 -97 22 -130 6 -33 12 -63 12 -67 0 -18 22 -17 136 1 68
11 148 23 177 27 l54 7 -7 31 c-3 17 -8 47 -11 66 -3 19 -9 58 -14 85 -5 28
-14 86 -20 130 -6 44 -16 101 -22 128 -12 55 6 54 -208 20z"
        />
        <path
          d="M0 565 l0 -565 47 0 c46 0 50 2 110 67 35 37 63 72 64 78 0 5 16 30
35 55 18 25 38 54 44 65 5 11 23 38 39 60 87 117 91 184 17 340 -26 55 -54
114 -62 131 -8 17 -29 47 -47 67 -18 19 -38 45 -46 58 -23 39 -104 141 -139
176 -65 64 -62 91 -62 -532z m145 305 c-11 -5 -27 -9 -35 -9 -9 0 -8 4 5 9 11
5 27 9 35 9 9 0 8 -4 -5 -9z"
        />
        <path
          d="M2990 1073 c-91 -13 -168 -28 -172 -31 -6 -6 22 -220 37 -294 6 -24
9 -25 38 -17 18 4 97 17 177 29 80 11 153 23 164 26 20 7 21 3 -7 214 l-13 95
-29 2 c-17 0 -104 -10 -195 -24z"
        />
        <path
          d="M1859 1076 c-2 -2 -74 -14 -159 -26 -85 -13 -156 -24 -158 -25 -2 -2
2 -32 9 -69 8 -50 15 -66 28 -66 9 0 90 13 181 29 l165 28 -3 54 c-1 30 -4 60
-7 67 -4 11 -46 17 -56 8z"
        />
        <path
          d="M1397 1005 c-66 -10 -81 -16 -100 -40 -12 -16 -49 -63 -82 -104 -100
-127 -115 -149 -115 -174 0 -23 84 -155 121 -190 17 -16 25 -16 156 3 76 11
150 20 165 20 14 0 28 5 30 11 2 7 -7 80 -20 163 -12 83 -29 189 -36 236 -8
60 -16 85 -27 86 -7 1 -49 -4 -92 -11z"
        />
        <path
          d="M4761 795 c-50 -68 -91 -129 -91 -134 0 -6 9 -15 20 -21 15 -8 20
-21 20 -51 0 -25 9 -53 25 -77 23 -34 33 -40 109 -60 139 -37 126 -56 126 191
l0 212 -51 33 c-28 17 -55 32 -59 32 -4 0 -48 -56 -99 -125z"
        />
        <path
          d="M1740 882 c-85 -15 -160 -30 -167 -35 -8 -5 -9 -17 -2 -40 5 -17 9
-44 9 -60 0 -16 7 -30 16 -34 9 -3 95 7 191 22 l175 28 -7 46 c-4 25 -9 53
-10 61 -2 8 -4 21 -4 28 -1 16 -20 15 -201 -16z"
        />
        <path
          d="M4079 876 c-2 -2 -85 -16 -184 -31 -99 -15 -182 -29 -184 -31 -2 -2
1 -30 8 -62 6 -32 13 -78 16 -102 2 -23 11 -91 20 -149 l17 -107 191 28 c105
16 193 30 195 33 3 3 -1 42 -8 87 -7 46 -14 97 -16 113 -10 96 -25 202 -29
213 -4 12 -17 16 -26 8z"
        />
        <path
          d="M4167 843 c-4 -3 -4 -18 0 -32 4 -14 23 -138 42 -275 24 -164 40
-251 49 -254 6 -2 12 3 12 11 0 9 4 17 8 19 12 5 204 271 209 289 3 10 -5 24
-19 34 -12 9 -61 44 -108 79 -170 124 -187 135 -193 129z"
        />
        <path
          d="M3470 781 c-163 -27 -165 -27 -161 -52 2 -13 6 -53 10 -89 l6 -65 70
2 c69 2 292 36 302 46 2 3 0 29 -6 59 -6 29 -13 69 -15 88 -2 26 -8 35 -22 36
-10 1 -93 -10 -184 -25z"
        />
        <path
          d="M3138 730 c-54 -9 -100 -19 -102 -21 -2 -2 -6 -20 -10 -40 l-6 -37
137 -100 c76 -55 140 -99 144 -97 6 4 1 44 -21 181 -6 34 -10 75 -10 91 0 40
-13 42 -132 23z"
        />
        <path
          d="M1810 708 c-211 -35 -221 -38 -216 -56 3 -9 8 -39 12 -65 l7 -49 56
7 c31 3 94 12 141 20 47 7 107 16 134 20 48 7 48 7 41 38 -3 18 -9 49 -12 70
-7 43 2 42 -163 15z"
        />
        <path
          d="M2619 651 c-91 -15 -170 -30 -175 -34 -15 -9 16 -187 32 -187 18 0
347 50 351 53 2 3 -15 137 -23 175 -2 12 -8 21 -12 21 -4 -1 -81 -14 -173 -28z"
        />
        <path
          d="M1027 630 c-23 -27 -21 -43 9 -79 30 -36 53 -39 77 -11 23 27 21 55
-5 85 -26 30 -57 32 -81 5z"
        />
        <path
          d="M828 562 l-97 -67 -1 -67 0 -67 73 -88 c40 -48 105 -130 146 -180
l73 -93 214 0 215 0 -103 103 c-57 57 -124 132 -151 168 -70 95 -199 279 -226
322 -12 20 -28 37 -34 37 -7 0 -56 -31 -109 -68z"
        />
        <path
          d="M2198 585 c-81 -13 -151 -25 -156 -26 -8 -4 13 -177 23 -187 6 -7
337 39 348 48 4 4 3 48 -4 98 -14 108 9 101 -211 67z"
        />
        <path
          d="M3605 566 c-38 -7 -114 -19 -168 -26 l-99 -14 7 -65 c7 -78 -6 -64
228 -233 159 -114 169 -119 183 -102 15 20 12 98 -6 174 -5 19 -16 90 -26 158
-14 98 -21 122 -33 121 -9 0 -47 -6 -86 -13z"
        />
        <path
          d="M2941 545 c-19 -14 -39 -26 -44 -28 -5 -1 -2 -46 8 -102 10 -55 17
-113 17 -128 l-1 -28 67 6 c37 4 96 13 132 20 36 7 95 16 132 20 82 9 81 18
-11 82 -36 26 -84 62 -107 80 -23 18 -45 33 -49 33 -5 0 -15 7 -24 15 -72 66
-70 65 -120 30z"
        />
        <path
          d="M1845 529 c-66 -10 -142 -21 -168 -25 -26 -4 -49 -10 -51 -13 -2 -3
2 -44 10 -91 7 -47 18 -121 24 -165 22 -163 21 -160 60 -159 19 0 53 3 75 7
22 3 87 13 145 21 57 9 108 20 113 25 5 5 5 30 -2 61 -6 28 -11 67 -11 86 0
21 -6 37 -14 40 -8 3 -62 -2 -121 -10 -129 -19 -155 -20 -155 -3 0 9 30 17 93
26 186 27 172 22 171 61 -1 19 -5 63 -9 98 -6 48 -11 62 -24 61 -9 -1 -70 -10
-136 -20z"
        />
        <path
          d="M1130 517 c-37 -19 -36 -42 5 -100 69 -100 63 -96 87 -67 31 38 21
115 -21 152 -36 32 -37 32 -71 15z"
        />
        <path
          d="M1454 470 c-208 -29 -194 -24 -194 -74 0 -29 -7 -52 -21 -70 l-21
-27 38 -47 c61 -76 213 -222 226 -217 7 2 29 6 48 9 129 19 122 16 117 45 -3
14 -17 107 -32 206 -15 99 -30 183 -34 186 -3 3 -60 -2 -127 -11z"
        />
        <path
          d="M4538 472 c-17 -7 -72 -75 -138 -172 -19 -28 -55 -77 -80 -110 -25
-32 -66 -88 -93 -124 l-47 -66 169 0 169 0 32 42 c112 151 197 268 209 291 13
25 12 28 -10 46 -13 10 -46 37 -74 60 -50 41 -91 51 -137 33z"
        />
        <path
          d="M440 447 c0 -12 -8 -38 -19 -57 -56 -105 -86 -155 -93 -158 -11 -5
-10 -22 1 -22 12 0 185 178 189 194 3 11 -57 66 -72 66 -3 0 -6 -10 -6 -23z"
        />
        <path
          d="M2617 415 c-75 -12 -140 -24 -143 -27 -4 -5 23 -189 29 -195 4 -4
362 52 361 57 -1 3 -8 47 -15 98 l-13 92 -40 -1 c-23 -1 -103 -12 -179 -24z"
        />
        <path
          d="M4085 403 c-137 -18 -298 -43 -302 -46 -4 -5 25 -188 31 -194 3 -3
40 0 83 6 149 20 298 43 301 46 2 2 -2 30 -8 63 -6 33 -11 76 -12 96 -1 39 -7
41 -93 29z"
        />
        <path
          d="M2355 373 c-22 -2 -80 -11 -130 -19 -49 -9 -103 -18 -120 -21 -16 -3
-32 -7 -34 -9 -2 -2 2 -41 10 -86 7 -46 13 -86 14 -90 1 -18 22 -19 107 -5 51
9 130 21 176 28 89 14 87 11 72 86 -5 26 -12 65 -15 86 -4 27 -10 37 -23 35
-9 -1 -35 -3 -57 -5z"
        />
        <path
          d="M4798 343 c-8 -10 -21 -28 -29 -39 -55 -82 -194 -270 -201 -272 -4
-2 -8 -10 -8 -18 0 -12 35 -14 205 -14 l205 0 0 180 0 180 -78 0 c-63 0 -82
-4 -94 -17z"
        />
        <path
          d="M496 271 c-32 -33 -53 -61 -48 -65 6 -3 13 -2 16 3 10 15 82 21 115
10 18 -6 34 -9 37 -7 5 6 -48 118 -56 118 -3 0 -32 -26 -64 -59z"
        />
        <path
          d="M3269 276 c-4 -4 -267 -46 -308 -49 -25 -2 -26 -12 -9 -120 13 -87
11 -85 105 -68 27 6 103 17 168 25 66 9 122 19 125 23 4 5 0 50 -8 101 -14 90
-15 92 -41 92 -15 0 -30 -2 -32 -4z"
        />
        <path
          d="M3375 248 c3 -18 12 -80 20 -137 7 -57 16 -105 18 -107 2 -3 82 -3
177 -2 l173 3 -97 70 c-53 39 -138 100 -188 138 -50 37 -95 67 -100 67 -5 0
-6 -15 -3 -32z"
        />
        <path
          d="M2715 189 c-66 -10 -135 -21 -153 -23 -18 -3 -37 -8 -43 -12 -10 -6
-8 -52 7 -128 l6 -29 175 5 c95 3 178 9 183 14 5 5 3 47 -3 99 -11 78 -15 90
-32 92 -11 1 -74 -7 -140 -18z"
        />
        <path
          d="M470 177 c-14 -8 -64 -50 -110 -95 l-85 -82 63 0 c37 0 69 5 76 13 7
6 53 46 101 87 72 62 84 75 68 81 -30 12 -86 10 -113 -4z"
        />
        <path
          d="M3955 143 c-93 -14 -166 -30 -174 -38 -16 -16 -14 -19 55 -73 40 -31
46 -32 131 -32 l89 0 39 53 c21 28 49 67 63 85 l24 32 -33 -1 c-19 -1 -106
-12 -194 -26z"
        />
        <path
          d="M2273 122 c-162 -25 -163 -26 -163 -51 0 -14 3 -36 6 -48 6 -23 8
-23 190 -23 101 0 184 3 183 8 -4 56 -28 137 -40 138 -7 1 -87 -10 -176 -24z"
        />
        <path
          d="M562 97 c-26 -24 -62 -55 -80 -70 l-34 -27 136 0 136 0 -7 47 c-12
101 -74 121 -151 50z"
        />
        <path
          d="M894 85 c-4 -11 -13 -27 -21 -36 -12 -15 -9 -18 27 -33 22 -9 49 -16
61 -16 24 0 17 15 -29 70 -28 32 -31 34 -38 15z"
        />
        <path
          d="M2029 86 c-2 -2 -74 -13 -159 -25 -183 -26 -181 -26 -174 -46 5 -13
34 -15 195 -15 205 0 195 -3 183 59 -6 27 -29 42 -45 27z"
        />
        <path d="M734 39 c8 -42 7 -41 54 -37 l41 3 -51 34 -51 33 7 -33z" />
        <path
          d="M3220 29 c-69 -10 -132 -21 -140 -23 -8 -2 54 -4 138 -5 152 -1 153
-1 150 21 -2 12 -7 22 -13 24 -5 1 -66 -6 -135 -17z"
        />
        <path d="M1575 14 l-60 -12 73 -1 c39 -1 72 3 72 8 0 16 -24 17 -85 5z" />
      </g>
    </svg>
  );
};

export default CesiumLoadingBackground;
